<template>
  <div>
    <div>
      <SectionHeader
        :text="$t('history.shortHistoryTitle')"
        :back-text="$t('history.shortHistoryTitleBack')"
      />

      <transition name="load">
        <h2 v-if="!data" class="text-center">
          <Loading />
        </h2>
        <div v-if="data" id="history-content">
          <div class="history-grid">
            <div class="empty pin">
              <img :src="require('../../assets/images/pin2.svg')" />
            </div>
            <div class="content"></div>
            <div
              v-for="item in data.length * 2"
              :class="{ empty: item % 2 === 1, content: item % 2 === 0 }"
              :key="item"
            >
              <span v-if="item % 2 === 0">{{ data[item / 2 - 1].text }}</span>
              <div class="vertical-line" v-if="item % 2 === 1"></div>
              <img
                :src="require('../../assets/images/notecircle.svg')"
                v-if="item % 2 === 1"
              />
              <div class="spacer" v-if="item % 2 === 0"></div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
import SectionHeader from "../SectionHeader";

export default {
  name: "FirstPage",
  components: {
    Loading,
    SectionHeader
  },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http.get("history/").then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.load-enter-active,
.load-leave-active {
  transition: 0.5s;
}

.load-leave-active {
  position: absolute;
}

.load-enter,
.load-leave-to {
  opacity: 0;
}

.history-grid {
  display: grid;
  grid-column-gap: 19px;
  grid-row-gap: 0px;
  -ms-grid-columns: 0.25fr 2fr;
  grid-template-columns: 0.25fr 2fr;
  -ms-grid-rows: auto auto auto auto auto auto auto auto auto;
  grid-template-rows: auto auto auto auto auto auto auto auto auto;
}

.empty {
  display: flex;
  align-items: center;
  position: relative;
}

.empty .vertical-line {
  height: 100%;
  width: 2px;
  background-color: #ddd;
  position: absolute;
  left: calc(50% - 1px);
}

.empty img {
  width: 65%;
  margin: 0 auto;
  z-index: 999;
  background-color: #f0f0f0;
}

.spacer {
  width: 80px;
  height: 2px;
  background-color: #ddd;
}

.pin img {
  width: 50%;
}

.content {
  display: flex;
  flex-direction: column;
}

.content > span {
  margin-top: 30px;
  margin-bottom: 30px;
  font-family: "Fira Sans", sans-serif;
  font-size: 1.25em;
  line-height: 24px;
  font-weight: 400;
}
</style>
